/*
import React, {useEffect, useState} from 'react';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

import format from "date-fns/format";
import ptBR from "date-fns/locale/pt-BR";
import {getLogs} from "services/Logs.service";

const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        backgroundColor: '#E4E4E4',
        fontSize: "14px"
    },
    section: {
        margin: 5,
        padding: 5,
        flexGrow: 1,
        fontSize: "14px"
    }
});

export const LogsUser = ({username}) => {

    const [data, setData] = useState([])

    useEffect(() => {
        async function loadLogs() {
            const response = await getLogs(username);
            if(response){
                setData(response);
            }
        }
        loadLogs();

    }, [username])

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View>
                    { data.map(log =>
                        <View key={log.id} style={styles.section}>
                            <Text>{ format(new Date(log.created_at),'dd/mm/yyyy - HH:mm', { locale: ptBR }) } - { log.username }</Text>
                            <Text>{ log.title } - { log.description }</Text>
                        </View>
                    )}
                </View>
            </Page>
        </Document>
    )

}


*/

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts'
import format from "date-fns/format";
import ptBR from "date-fns/locale/pt-BR";

export function generatePdf(data) {

    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    const header = [
        {
            text: 'Logs',
            fontSize: 15,
            bold: true,
            margin: [15,20,0,45]
        }
    ];

    const dados = data.map((item) => {
        return [
            {text: item.title, fontSize: 10, margin: [0,2,0,2]},
            {text: item.description, fontSize: 10, margin: [0,2,0,2]},
            {text: item.username, fontSize: 10, margin: [0,2,0,2]},
            {text: format(new Date(item.created_at), 'dd/MM/yyyy - HH:mm', {locale: ptBR}) , fontSize: 10, margin: [0,2,0,2]}
        ]
    })

    const content = [
        {
            table: {
                headerRows: 1,
                widths: ['*','*','*','*'],
                body: [
                    [
                        {text: 'Ação', style: 'tableHeader', fontSize: 10},
                        {text: 'Descrição', style: 'tableHeader', fontSize: 10},
                        {text: 'Usuário', style: 'tableHeader', fontSize: 10},
                        {text: 'Data', style: 'tableHeader', fontSize: 10}
                    ],
                    ...dados
                ]
            },
            layout: 'headerLineOnly'
        }
    ];

    function Footer(currentPage, pageCount) {
        return [
            {
                text: currentPage.toString() + ' / ' + pageCount,
                alignment: 'right',
                fontSize: 10,
                margin: [0,10,20,0]
            }
        ]
    }

    const docDefinitions = {
        pageSize: 'A4',
        pageMargins: [15,50,15,40],
        header: [header],
        content: [content],
        footer: Footer
    }

    pdfMake.createPdf(docDefinitions).download();

}